import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getAutomations } from 'modules/settings/api';

export const useQueryAutomations = () => {
  return useQuery(QUERY_KEYS.SETTINGS_AUTOMATION, getAutomations);
};
